import Vue from 'vue'
import Vuex from 'vuex'
import events from '@/lib/events.js'
import logger from '@/lib/logger.js'
import UserPoint from '@/lib/UserPoint.js'

Vue.use(Vuex)

const eventRaiserPlugin = (store) => {
    store.subscribe((mutation, state) => {
        logger.log('Notify state mutation: ' + mutation.type)
        switch(mutation.type) {
            case 'setUser':
                events.$emit(events.EVT_USER_CHANGED)
                break
            case 'setForecastInventory':
                events.$emit(events.EVT_FORECAST_INV_CHANGED)
                break
            case 'setUserPoints':
                events.$emit(events.EVT_USER_POINTS_CHANGED)
                break
            case 'deleteUserPoint':
                // This event is reaised in the mutation
                break
            case 'setForecast':
                events.$emit(events.EVT_FORECAST_CHANGED)
                break
            case 'setForecastVarInventory':
                events.$emit(events.EVT_FORECAST_VAR_INV_CHANGED)
                break
            case 'setLayerInventory':
                events.$emit(events.EVT_LAYER_INV_CHANGED)
                break
            case 'logout':
                events.$emit(events.EVT_USER_CHANGED)
                break
            case 'setLayerOpacity':
                events.$emit(events.EVT_LAYER_OPACITY_CHANGED)
                break
            case 'setDualPane':
                events.$emit(events.EVT_DUAL_PANE_CHANGED)
                break
            case 'addPoint':
                // This event is raised in the mutation
                break
            case 'setConfig':
                events.$emit(events.EVT_CONFIG_CHANGED)
                break
        }
    })
}

const store = new Vuex.Store({
    state: {
        user: null,
        userPoints: [],
        forecastInventory: null,
        forecast: null,
        forecastVarInventory: null,
        layerInventory: null,
        appSettings: {
            layerOpacity: 0.8,
            dualPane: true,
            showFullHistoricalInPopup: false
        },
        userConfig: {
            autoLoadCID: ''
        },
        toolbarHeight: 0
    },
    mutations: {
        setToolbarHeight(state, value) {
            state.toolbarHeight = value
        },
        setConfig(state, data) {
            state.userConfig.autoLoadCID = data.userLoadCID
        },
        setUser(state, data) {
            state.user = data
            state.userConfig = {
                autoLoadCID: data.autoLoadCID
            }
        },
        setForecastInventory(state, data) {
            state.forecastInventory = data            
        },
        setUserPoints(state, data) {
            logger.log('Store::setUserPoints', data)

            if (data == null)
                data = []
            
            state.userPoints = data.filter((point) => point instanceof UserPoint)
        },
        setForecast(state, data) {
            state.forecast = data            
        },
        setForecastVarInventory(state, data) {
            state.forecastVarInventory = data
        },
        setLayerInventory(state, data) {
            state.layerInventory = data
        },
        setLayerOpacity(state, data) {
            let num = Number(data)
            num = Math.min(1.0, Math.max(0.0, data))
            state.appSettings.layerOpacity = data
        },        
        setDualPane(state, data) {
            state.appSettings.dualPane = Boolean(data)
        },
        setShowFullHistoricalInPopup(state, data) {
            state.appSettings.showFullHistoricalInPopup = data
        },
        addPoint(state, data) {
            if (!(data instanceof UserPoint))
                throw new Error('Object is not instance of UserPoint')
            
            let points = state.userPoints
            points.push(data)
            state.userPoints = points

            events.$emit(events.EVT_POINT_ADDED, data)
        },
        deleteUserPoint(state, deletedPoint) {
            if (deletedPoint instanceof UserPoint) 
                deletedPoint = deletedPoint.id

            if (typeof deletedPoint != 'string')
                return
            
            let points = state.userPoints

            if (!(points instanceof Array))
                return
            
            points = points.filter((point) => point.id != deletedPoint)
            
            state.userPoints = points

            events.$emit(events.EVT_POINT_DELETED, deletedPoint)
        },
        logout(state) {
            state.user = null            
        },        
    },
    plugins: [eventRaiserPlugin]
})

export default store 